import React from 'react';

/**
 * Vertical event timeline — events: [{ ts, title, detail, color }]
 * Used in ticket / accessory-request view modals to show what happened when.
 */
export default function EventTimeline({ events, loading }) {
  if (loading) {
    return (
      <div className="flex items-center gap-2 py-4 justify-center text-xs" style={{ color: '#334155' }}>
        <div className="w-3.5 h-3.5 rounded-full border-2 border-blue-500 border-t-transparent animate-spin"/>Loading timeline…
      </div>
    );
  }
  if (!events?.length) {
    return <div className="text-xs text-center py-4" style={{ color: '#334155' }}>No events recorded</div>;
  }
  return (
    <div style={{ position: 'relative', paddingLeft: 18 }}>
      {/* spine */}
      <div style={{ position: 'absolute', left: 5, top: 8, bottom: 8, width: 2, background: 'rgba(255,255,255,0.07)', borderRadius: 2 }}/>
      <div className="space-y-3">
        {events.map((e, i) => {
          const d = new Date(e.ts);
          return (
            <div key={i} style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: -18, top: 4, width: 12, height: 12, borderRadius: 99, background: `${e.color}22`, border: `2px solid ${e.color}`, boxShadow: `0 0 6px ${e.color}55` }}/>
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="text-xs font-semibold" style={{ color: e.color }}>{e.title}</span>
                <span style={{ fontSize: 10.5, color: '#475569', fontVariantNumeric: 'tabular-nums' }}>
                  {d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} · {d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
              {e.detail && <div className="text-xs mt-0.5" style={{ color: '#94a3b8' }}>{e.detail}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
